import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const TextInput = ({
  value,
  onChange,
  onBlur,
  placeholder,
  type = 'text',
  style,
  className,
  prefixIcon,
  ...props
}) => {
  const { theme, whitelabelEnabled } = useTheme();

  // Só aplicar cores customizadas se whitelabel estiver ativo
  const inputStyle = whitelabelEnabled ? {
    color: theme.textSecondary,
    borderColor: theme.border,
    ...style
  } : style;

  return (
    <Input
      type={type}
      value={value}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      onBlur={onBlur}
      placeholder={placeholder}
      prefix={prefixIcon}
      style={inputStyle}
      className={className}
      {...props}
    />
  );
};

TextInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  prefixIcon: PropTypes.node,
};

export default TextInput; 